<!-- Basic article is dependent on parent's dialogue for the bottom link button to work -->
<template>
  <div class="basic-article section">
    <div
      class="section__wrapper"
      :class="{
        'image-on-left': isImagePositionLeft,
        'centered-content': isContentCentered,
      }"
    >
      <div class="basic-article__column">
        <h2 v-if="article.heading">{{ article.heading }}</h2>
        <div v-html="getLinkFormattedContent"></div>
        <template v-if="bottomLink?.route && bottomLink?.text">
          <div class="bottom-link">
            <action-link :to="bottomLink?.route" v-if="bottomLink?.type === 'link'" tabindex="0">
              {{ bottomLink.text }}
            </action-link>
            <form-button
              :text="bottomLink?.text"
              theme="primary"
              @click.native="openAgencyForm()"
              v-if="bottomLink?.type === 'button'"
            ></form-button>
          </div>
        </template>
      </div>

      <div class="basic-article__column" v-if="article.imageUrl">
        <div
          v-if="article.imageType === 'contain' || article.imageType === 'cover'"
          :class="`basic-article__image ${article.imageType === 'contain' ? 'contain' : 'cover'}`"
          :style="`background-image: url(${article.imageUrl}?fm=webp)`"
        ></div>
        <div v-else class="basic-article__image">
          <img :src="article.imageUrl" :alt="`Kuvituskuva: ${article.heading}`" aria-hidden="true" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import type { BasicArticleSectionType, BottomLinkType } from '@/schemas/landingPageSchema';
import { defineAsyncComponent, defineComponent, type PropType } from 'vue';
import ActionLink from '@/app/components/action-link/action-link.vue';

export default defineComponent({
  components: {
    FormButton: defineAsyncComponent(() => import('@/app/components/form-button/form-button.vue')),
    ActionLink,
  },
  name: 'basic-article',
  props: {
    article: {
      type: Object as PropType<BasicArticleSectionType['content']>,
      required: true,
    },
    bottomLink: {
      type: Object as PropType<BottomLinkType>,
      required: false,
    },
  },
  methods: {
    openAgencyForm() {
      this.$bus.$emit('openDialogue', 'contact-full');
    },
  },
  computed: {
    isImagePositionLeft() {
      return this.article.imagePosition && this.article.imagePosition === 'left';
    },
    isContentCentered() {
      return !this.article.imageUrl;
    },
    getLinkFormattedContent() {
      return this.article.text.replace(
        /(<a\s+[^>]*href="(?!\/)(?!https?:\/\/(?:[a-zA-Z0-9-]+\.)?op-koti\.fi)[^"]*"[^>]*>)(.*?)(<\/a>)/g,
        '$1$2<i class="icon-linkexternal" role="img" aria-label="Avautuu toiseen verkkopalveluun -ikoni"></i>$3'
      );
    },
  },
});
</script>
